// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__3bjn6","confirmed":"Cards_confirmed__iMMyf","recovered":"Cards_recovered__1aizD","deaths":"Cards_deaths__Qdjzq"};